import type { FC } from 'react'
import React, { useEffect } from 'react'
import type { ColorScheme } from './use-color-scheme.js'

export interface TunaThemeProps {
  colorScheme?: ColorScheme
  /** @default 14 */
  textSize?: number
  children?: React.ReactNode
}

/**
 * TunaTheme applies the color scheme class to the document root.
 * Design tokens are provided by tokens.css (imported at app root).
 */
export const TunaTheme: FC<TunaThemeProps> = ({ colorScheme, children, textSize = 14 }) => {
  useEffect(() => {
    if (!colorScheme) {return}
    document.documentElement.classList.remove('light', 'dark')
    document.documentElement.classList.add(colorScheme)
  }, [colorScheme])

  useEffect(() => {
    document.documentElement.style.setProperty('--tuna-typography-fontSize', `${textSize}px`)
  }, [textSize])

  return <>{children}</>
}
